module.exports = __webpack_public_path__ + "static/media/List.5863c517.svg";